import { baseApi } from './baseApi';

/**
 * Dashboard API endpoints
 * Handles dashboard statistics and analytics
 */
export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /dashboard/statistics - Fetch dashboard statistics
    getDashboardStatistics: builder.query({
      query: () => '/dashboard/statistics',
      providesTags: ['Dashboard'],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetDashboardStatisticsQuery,
} = dashboardApi;

